import { render, staticRenderFns } from "./SLogo.vue?vue&type=template&id=5a05fedc&"
import script from "./SLogo.vue?vue&type=script&lang=ts&"
export * from "./SLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports